import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";
import NotFound from "pages/NotFound";
import AssetLibrary from './pages/asset-library';
import ContentCalendar from './pages/content-calendar';
import Login from './pages/login';
import ProvidersDashboard from './pages/providers-dashboard';
import InviteSignup from './pages/invite-signup';
import ScheduleMarketingSupport from './pages/schedule-marketing-support';
import EmailCampaigns from './pages/email-campaigns';
import PressReleaseTemplate from './pages/press-release-template';
import AdminDashboard from './pages/admin-dashboard';
import UserManagement from './pages/user-management';
import MarketingSupportCalendar from './pages/marketing-support-calendar';
import BestPractices from './pages/best-practices';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Public routes - accessible to all guests */}
        <Route path="/" element={<ProvidersDashboard />} />
        <Route path="/asset-library" element={<AssetLibrary />} />
        <Route path="/content-calendar" element={<ContentCalendar />} />
        <Route path="/providers-dashboard" element={<ProvidersDashboard />} />
        <Route path="/invite-signup" element={<InviteSignup />} />
        <Route path="/schedule-marketing-support" element={<ScheduleMarketingSupport />} />
        <Route path="/email-campaigns" element={<EmailCampaigns />} />
        <Route path="/press-release-template" element={<PressReleaseTemplate />} />
        <Route path="/best-practices" element={<BestPractices />} />
        <Route path="/login" element={<Login />} />
        
        {/* Protected admin routes - require authentication */}
        <Route path="/admin-dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        <Route path="/user-management" element={<ProtectedRoute><UserManagement /></ProtectedRoute>} />
        <Route path="/marketing-support-calendar" element={<ProtectedRoute><MarketingSupportCalendar /></ProtectedRoute>} />
        
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
